import { render, staticRenderFns } from "./com-dialog.vue?vue&type=template&id=f959158e"
import script from "./com-dialog.vue?vue&type=script&lang=js"
export * from "./com-dialog.vue?vue&type=script&lang=js"
import style0 from "./com-dialog.vue?vue&type=style&index=0&id=f959158e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports